import GenerateCode from './GenerateCode';

export default GenerateCode;
